import React from 'react';
import GeneralMenu from '@/components/navigation/GeneralMenu';
import SalaryOverview from './SalaryOverview';
import SalaryExperience from './SalaryExperience';
import SalaryEducation from './SalaryEducation';
import SalaryIndustry from './SalaryIndustry';
import SalaryCity from './SalaryCity';
import JobTitleCitySearch from '../JobTitleCitySearch';
import { JobTitleContext } from '@/context/create-context';
import { SALARY_INSIGHT_ITEMS } from '@/constants/job-title';

const SalaryInsight = (props: {
  show: boolean;
  salaryData: Record<string, any>;
  experienceData: Record<string, any>;
  industryData: Record<string, any>;
  educationData: Record<string, any>;
  cityData: Record<string, any>;
}) => {
  const {
    show,
    salaryData,
    experienceData,
    educationData,
    industryData,
    cityData,
  } = props;
  const {
    jobTitle: { salary_details, job_open_details },
  } = React.useContext(JobTitleContext);

  return (
    <div
      className={`relative ${show ? 'max-h-full' : 'max-h-0 overflow-hidden'}`}
    >
      <GeneralMenu menuList={SALARY_INSIGHT_ITEMS} />
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold shrink-0 mr-4">薪酬概览</h2>
        <JobTitleCitySearch />
      </div>
      <SalaryOverview
        id={SALARY_INSIGHT_ITEMS[0].id}
        salaryData={salaryData}
        salaryDetails={salary_details}
        jobOpenDetails={job_open_details}
      />
      <p className="my-8 text-xl font-semibold">四大影响薪酬的核心维度</p>
      <SalaryExperience
        id={SALARY_INSIGHT_ITEMS[1].id}
        experienceData={experienceData}
      />
      <SalaryEducation
        id={SALARY_INSIGHT_ITEMS[2].id}
        educationData={educationData}
      />
      <SalaryIndustry
        id={SALARY_INSIGHT_ITEMS[3].id}
        industryData={industryData}
      />
      <SalaryCity id={SALARY_INSIGHT_ITEMS[4].id} cityData={cityData} />
    </div>
  );
};

export default SalaryInsight;
